import { useState, useEffect } from 'react'
import { TableDataLoading } from 'global/globalComponents/TailwindTable/TailwindTable'
import {
  Th,
  Thead,
  TableContainer,
  Tbody,
  Td,
  Tr
} from 'global/globalComponents/TailwindTable/TailwindTable'
import NestedTimesheetTable from './NestedTable'
import { ArrowRight } from '@material-ui/icons'
import clsx from 'clsx'
import timesheetStyles from './timesheetStyles'
import { ReactComponent as Pen } from 'static/svg/edit.svg'
import ManualTimeEntry from './ManualTimeEntry'
import getTimeString from './TimesheetFunctions'
import { useDispatch, useSelector } from 'react-redux'
import { CustomTooltip } from 'global/globalComponents'
import { useTranslation } from 'react-i18next'
import TaskPanel from 'components/Workspace/Panel/TaskPanel'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { fetchTaskById } from 'thunks/task/actions'
import { fireErrorToaster } from 'thunks/fireToaster/actions'
import { fetchAllWorkspacesForCurrentUser } from 'thunks/workspace/actions'

const MyTimesheets = ({
  loading,
  userId,
  timesheetData,
  setTimesheetData,
  selectedDays,
  startTime,
  endTime,
  // addNewTimesheetData,
  elmFor,
  setDownloadData
}) => {
  const { t, i18n } = useTranslation()
  const classes = timesheetStyles()
  const meData = useSelector(state => state.me.data)
  const [expanded, setExpanded] = useState('')
  const [manualData, setManualData] = useState({
    anchorEl: null,
    data: {}
  })
  const history = useHistory()
  const dispatch = useDispatch()
  const {
    data: boardNewTasksData,
    listViewTasks
    // data: userTasksData
    // loading: { all: loadingTasks }
  } = useSelector(state => state.userTasks)
  const {
    fetchedFirstTime,
    loading: projectsLoading,
    data: allProjects
  } = useSelector(state => state.userWorkspaces)

  const [taskPanel, setTaskPanel] = useState({
    open: false,
    data: {},
    workspace: {}
  })

  useEffect(() => {
    if (!fetchedFirstTime) {
      dispatch(fetchAllWorkspacesForCurrentUser())
    }
  }, [fetchedFirstTime])

  useEffect(() => {
    const downloadedData = []
    timesheetData?.forEach((project, index) => {
      let taskData = project.tasks?.map((item, index) => ({
        Project: project.name ?? 'Deleted Project (Project has been deleted)',
        Task: item.title ?? 'Deleted Task (Task has been deleted)',
        'Total Time': getNestedTimeOfProject(
          item.data?.filter(
            time =>
              time.start >= new Date(startTime).getTime() &&
              time.start <= new Date(endTime).getTime()
          )
        ),
        ...timesheetDataFormat(item)
      }))
      downloadedData.push(...taskData)
    })
    setDownloadData(prev => ({ ...prev, data: downloadedData }))
  }, [timesheetData])

  const timesheetDataFormat = item => {
    let data = {}
    selectedDays.forEach(
      day => (data[day] = getNestedTimeByDay(item.data, day) || '')
    )
    return data
  }

  const getTimeOfProject = project => {
    let data = []
    project.tasks.forEach(item => {
      data = [...data, ...item.data]
    })
    const time = data
      .filter(
        time =>
          time.start >= new Date(startTime).getTime() &&
          time.start <= new Date(endTime).getTime()
      )
      .reduce((acc, obj) => acc + obj.duration, 0)

    return getTimeString(time / 1000)
  }

  const getTimeByDay = (project, day) => {
    let data = []
    project.tasks.forEach(item => {
      data = [...data, ...item.data]
    })
    const dayData = data.filter(el => new Date(el.start).toDateString() === day)
    const time = dayData.reduce((acc, obj) => acc + obj.duration, 0)
    return getTimeString(time / 1000)
  }

  const getNestedTimeOfProject = data => {
    const time = data.reduce((acc, obj) => acc + obj.duration, 0)
    return getTimeString(time / 1000)
  }

  const getNestedTimeByDay = (data, day) => {
    const dayData = data.filter(el => new Date(el.start).toDateString() === day)
    const time = dayData.reduce((acc, obj) => acc + obj.duration, 0)
    return getTimeString(time / 1000)
  }

  const handleListExpansion = id => {
    if (expanded === id) {
      setExpanded('')
    } else {
      setExpanded(id)
    }
  }

  const handlePopup = (e, data) => {
    e.stopPropagation()
    if (!manualData.anchorEl) {
      setManualData(prev => ({ ...prev, anchorEl: e.currentTarget, data }))
    } else {
      setManualData(prev => ({ ...prev, anchorEl: null, data: {} }))
    }
  }

  const addNewTimesheetData = (wsId, taskId, newData) => {
    setTimesheetData(prev => ({
      ...prev,
      data: prev.data.map(entry => {
        if (entry._id === wsId) {
          let newTasksData = [...entry.tasks]
          const taskObj = entry.tasks.find(task => task._id === taskId)
          if (taskObj) {
            newTasksData = entry.tasks.map(task => {
              if (task._id === taskId) {
                return { ...task, data: [...task.data, newData] }
              } else {
                return task
              }
            })
          } else {
            newTasksData = [
              ...entry.tasks,
              {
                _id: newData.task?._id,
                title: newData.task?.title,
                data: [newData]
              }
            ]
          }

          return { ...entry, tasks: newTasksData }
        }
        return entry
      })
    }))
  }

  const deleteOneTimeEntry = (wsId, taskId, newData) => {
    setTimesheetData(prev => ({
      ...prev,
      data: prev.data.map(entry => {
        if (entry._id === wsId) {
          let newTasksData = [...entry.tasks]
          const taskObj = entry.tasks.find(task => task._id === taskId)
          if (taskObj) {
            newTasksData = entry.tasks.map(task => {
              if (task._id === taskId) {
                return {
                  ...task,
                  data: [...task.data].filter(el => el._id !== newData._id)
                }
              } else {
                return task
              }
            })
          }
          return { ...entry, tasks: newTasksData }
        }
        return entry
      })
    }))
  }
  const openEditTaskPanel = taskId => {
    const task = boardNewTasksData[taskId]
    // const task = allTasksData.find(item => item._id === taskId)

    if (task) {
      const workspace = allProjects.find(item => item._id === task.workSpace)

      setTaskPanel(prev => ({
        data: task,
        open: true,
        workspace
      }))
    } else {
      setTaskPanel(prev => ({ ...prev, open: true }))
      dispatch(
        fetchTaskById({ taskId }, (res, err) => {
          if (err) dispatch(fireErrorToaster(res))
          else {
            const workspace = allProjects.find(
              item => item._id === res.workSpace
            )
            setTaskPanel(prev => ({ ...prev, data: res, workspace }))
          }
        })
      )
    }
  }

  const closeEditTaskPanel = () => {
    setTaskPanel(prev => ({
      ...prev,
      open: false
    }))
  }

  return (
    <>
      <TableContainer mb={2} shadow="none">
        <Thead>
          <Th className="w-44 whitespace-nowrap">{t('PROJECTS')}</Th>
          <Th center className="capitalize">
            {t('TOTAL_TIME')}
          </Th>
          {selectedDays?.map(day => (
            <Th
              className={
                clsx()
                // 'text-right'
                // manualData.data.day === day && `${classes.activeCell}`
              }
            >
              <span className="block font-medium capitalize">
                {day.split(' ')[0]}
              </span>
              <span className="font-base tect-xs text-gray-500 capitalize">
                {day.split(' ').slice(1, 3).join(' ')}
              </span>
            </Th>
          ))}
        </Thead>
        <Tbody>
          {loading ? (
            <TableDataLoading cols={9} />
          ) : timesheetData?.length > 0 ? (
            timesheetData?.map((item, index) => (
              <>
                <Tr>
                  <Td className="pl-1 whitespace-nowrap flex items-center space-x-1 text-custom-table-primaryText">
                    <span
                      onClick={() => handleListExpansion(item._id)}
                      className={clsx(
                        {
                          expanded: expanded === item._id
                        },
                        classes.btn
                      )}
                    >
                      <ArrowRight />
                    </span>
                    {item.name ? (
                      <span className="dark:text-dark-light">{item.name}</span>
                    ) : (
                      <span className="text-gray-500 dark:text-dark-light">
                        Deleted
                      </span>
                    )}
                  </Td>
                  <Td className="text-center text-xs dark:text-dark-light">
                    {getTimeOfProject(item)}
                  </Td>
                  {selectedDays.map(day => (
                    <Td
                      className={clsx(
                        'px-4 py-2 text-xs text-left',
                        classes.editTime,
                        {
                          active:
                            manualData.data.sheetData?._id === item._id &&
                            manualData.data.day === day
                        }
                      )}
                    >
                      <div className="flex items-center">
                        <div className="text-xs dark:text-dark-light">
                          {getTimeByDay(item, day) ? (
                            <span className="mr-2 dark:text-dark-light">
                              {getTimeByDay(item, day)}
                            </span>
                          ) : (
                            !(userId === meData._id && item._id) && '-'
                          )}
                        </div>
                        {userId === meData._id && item._id && (
                          <CustomTooltip title={t('ADD_MULTIPLE_TIME_ENTRIES')}>
                            <div
                              className="pen opacity-1 cursor-pointer"
                              onClick={e =>
                                handlePopup(e, {
                                  sheetData: item,
                                  day: day
                                })
                              }
                            >
                              <Pen className="text-primary-mid-dark-2 dark:text-dark-light" />
                            </div>
                          </CustomTooltip>
                        )}
                      </div>
                    </Td>
                  ))}
                </Tr>
                {expanded === item._id && (
                  <NestedTimesheetTable
                    timesheetData={item.tasks}
                    selectedDays={selectedDays}
                    startTime={startTime}
                    endTime={endTime}
                    openEditTaskPanel={openEditTaskPanel}
                  />
                )}
              </>
            ))
          ) : (
            <Tr className="bg-white dark:bg-dark-main dark:text-dark-light">
              <th
                colSpan="9"
                className="text-left py-3 px-6 text-gray-500 font-normal dark:text-dark-light"
              >
                {t('NO_DATA_AVAILABLE')}
              </th>
            </Tr>
          )}
        </Tbody>
      </TableContainer>
      <ManualTimeEntry
        anchorEl={manualData.anchorEl}
        onClose={handlePopup}
        data={manualData.data}
        addNewTimesheetData={addNewTimesheetData}
        deleteOneTimeEntry={deleteOneTimeEntry}
      />
      <TaskPanel
        taskData={taskPanel.data}
        open={taskPanel.open}
        onClose={closeEditTaskPanel}
        workspace={taskPanel.workspace}
        inDashboardArea={true}
        isOutsideBoardArea={true}
      />
    </>
  )
}

export default MyTimesheets
